module.exports = "/static-assets/_next/static/images/dog-collar-ddd1a93fe770ec1bc87cd29d893dca9a.png";